/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PurchaseInterface, PurchaseProductInterface, SchoolBillingInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class PurchaseApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'Purchases');
  }

  getPurchasesForSchoolYear(schoolYear: number): Observable<PurchaseInterface> {
    const path = `school-year/${schoolYear}`;
    return this.get(path, undefined);
  }

  finalisePurchases(purchaseIds: number[]): Observable<{
    purchases: PurchaseInterface[];
    purchaseProducts: PurchaseProductInterface[];
    schoolBillings: SchoolBillingInterface[];
  }> {
    const path = `finalise`;
    const body = purchaseIds;
    return this.post(path, undefined, body);
  }
}
